import type {LocalizationContextType} from 'localization/context/types';
import type {LinkedRoleCodeListId} from 'schemaDefinition/types/linkTypes';
import {entityLinkTypes} from '../entityLinks';
import {getLinkedSourceRoleCodelist} from './getSourceLinkedRoleCodelist';

export const getLinkedRoleCodelist = (
  codelistId: LinkedRoleCodeListId,
  localization?: LocalizationContextType,
) => {
  return getLinkedSourceRoleCodelist(codelistId, entityLinkTypes, localization);
};
